// extracted by mini-css-extract-plugin
export default {"mCard":"sB-z","image":"tB-z","imageNoBackground":"uB-z","imageHasCategory":"vB-z","fullWidth":"wB-z"};